import MenuPage from '/src/pages/index/Menu.vue'
import ConditionsPage from '/src/pages/index/Conditions.vue'
import RestaurantsPage from '/src/pages/index/Restaurants.vue'
import OrderPage from '/src/pages/index/Order.vue'
import SuccessPage from '/src/pages/index/SuccessPage.vue'
// import AboutPage from '/src/pages/index/About.vue'
import ReserveTablePage from '/src/pages/index/ReserveTable.vue'

const IndexPage = () => import('/src/pages/Index.vue')

// const MenuPage = () => import('/src/pages/clients_front/Menu.vue')
// const ConditionsPage = () => import('/src/pages/clients_front/Conditions.vue')
// const RestaurantsPage = () => import('/src/pages/clients_front/Restaurants.vue')

const indexRoutes = {
  path: '/',
  component: IndexPage,
  // meta: { businessProduct: '' },
  children: [
    {
      path: '/',
      component: MenuPage,
      name: 'Index',
      meta: { title: 'Ресторан Мангал и Гриль', leftBarComponent: 'DesktopCategories' }
    },
    {
      path: 'menu/:category/:subcategory?',
      component: MenuPage,
      name: 'MenuCategory',
      meta: { title: 'Ресторан Мангал и Гриль - меню', leftBarComponent: 'DesktopCategories' }
    },
    {
      path: 'conditions',
      component: ConditionsPage,
      name: 'Conditions',
      meta: { title: 'Доставка и оплата', leftBarComponent: 'ConditionsLeftBar', headerTitle: 'Доставка и оплата' }
    },
    {
      path: 'restaurants',
      component: RestaurantsPage,
      name: 'Restaurants',
      meta: { title: 'Наши рестораны', headerTitle: 'Рестораны' }
    },
    {
      path: 'order',
      component: OrderPage,
      name: 'Order',
      meta: { title: 'Оформление заказа', headerTitle: 'Оформление заказа' }
    },
    {
      path: 'thankyou/:type',
      component: SuccessPage,
      name: 'SuccessPage',
      meta: { title: 'Спасибо за заказ' }
    },
    // {
    //   path: 'about',
    //   component: AboutPage,
    //   name: 'About',
    //   meta: { title: 'Шесть', leftBarComponent: 'DesktopCategories', headerTitle: 'О доставке' }
    // },
    {
      path: 'reserve/:restaurant',
      component: ReserveTablePage,
      name: 'ReserveTable',
      meta: { title: 'Шесть', headerTitle: 'Бронирование столика' }
    }
  ]
}

// const tryCustomization = {
//   path: '/try-customization',
//   name: 'TryCustomization',
//   component: TryCustomization,
//   meta: { globalPlacement: 'landing' },
//   children: [
//     {
//       path: ':hid',
//       component: SingleStepOrder,
//       name: 'SingleStepOrderInTryCustomization'
//     }
//   ]
// }

// const indexEmailThankYouRoute = {
//   path: '/thankyou',
//   name: 'ThankYouForSubscribe',
//   component: EmailThankYouPage
// }
//
// const indexEmailCollectRoute = {
//   path: '/nyemail',
//   name: 'CollectEmail',
//   component: CollectEmailPage
// }
//
// const weekMenuRoute = {
//   path: '/week-menu',
//   name: 'WeekMenu',
//   component: FullMenu,
//   meta: { globalPlacement: 'landing' }
// }

export default [indexRoutes]



// WEBPACK FOOTER //
// ./src/router/modules/indexRoutes.js